import Vue from 'vue'
import Vuex from 'vuex'
import http from './http'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: '',
    user: JSON.parse(localStorage.getItem('user') || null),
    update: 1,
    newRefId: -1,
    newRefFieldName: '',
    refUpdate: 1,
    selectedSchema: null
  },
  mutations: {
    auth_request (state) {
      state.status = 'loading'
    },
    auth_success (state, user) {
      console.log('auth_success')
      console.log(user)
      state.status = 'success'
      state.user = user
    },
    auth_error (state) {
      state.status = 'error'
    },
    logout (state) {
      state.status = ''
      state.user = null
    }
  },
  actions: {
    login ({commit}, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        http.post('/login', user)
          .then(resp => {
            console.log('store login respose ', resp.data)
            const user = resp.data
            localStorage.setItem('user', JSON.stringify(user))
            // Add the following line:
            http.defaults.headers.common['Authorization'] = user.token
            commit('auth_success', user)
            resolve(resp)
          })
          .catch(err => {
            console.log('store login catched error ' + err)
            commit('auth_error')
            localStorage.removeItem('user')
            reject(err)
          })
      })
    },
    logout ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('logout')
        localStorage.removeItem('user')
        delete http.defaults.headers.common['Authorization']
        resolve()
      })
    }
  },
  getters: {
    isLoggedIn: state => !!state.user,
    authStatus: state => state.status,
    isAdmin: state => {
      return state.user != null && state.user.admin
    },
    username: state => {
      return state.user.userID
    },
    token: state => state.user.token
  }
})



// WEBPACK FOOTER //
// ./src/store.js